import trackingStepBack from '../tracking_back_link_mobile.js';
import {
  trackingMultiAdLink,
  trackingSubmitionError,
} from '../tracking_post_ad.js';
import { fetchData } from '../../../helpers/base_data_fetcher';
import addressLookupSearch from '../components/find_address/address_lookup_search';
import addressLookupPostcode from '../components/find_address/address_lookup_postcode';
import { getActiveTestVariant } from '../../../experiments/helpers/ab_tests';
import '../../../../sass/experiments/postcode_view_desktop.scss';

trackingStepBack();
trackingMultiAdLink();
trackingSubmitionError();

async function initAddressLookup(activate) {
  const address_lookup_block = document.getElementById('address_lookup');
  const postcode_input = document.getElementById('standard-postcode-input');

  if (activate) {
    // Remove the "control" postcode input
    if (postcode_input) {
      postcode_input.remove();
    }

    // Display address_lookup block
    address_lookup_block.classList.remove('hidden');

    // Apply experiment test content
    document.querySelectorAll('[data-test-content]').forEach((element) => {
      element.innerText = element.dataset.testContent;
    });

    // Make it happen...
    addressLookupSearch({
      allowManualAddress: true,
    });
  } else {
    // Otherwise remove address_lookup element
    address_lookup_block.remove();
  }
}

const stepOneInit = () => {
  Promise.all([fetchData('site')]).then(([site]) => {
    if (site.country === 'US') {
      const is_mobile = !!site.mobile;
      const address_lookup_mobile_experiment = getActiveTestVariant(
        'address_lookup_v2_offered_ads_no_placeholder_hint_above_entry_field_us_mobile',
      );

      if (is_mobile) {
        // On mobile show address lookup when in experiment
        initAddressLookup(address_lookup_mobile_experiment);
      } else {
        // On desktop always show address lookup
        initAddressLookup(true);
      }
      return;
    }

    // Show postcode lookup for UK
    addressLookupPostcode();
  });
};

stepOneInit();

// Step 1 advertiser role radio button visibility
const advertiserRoleButton = document.getElementById('toggleAdvertiserRole');
const checkedRadioButton = document.querySelector(
  'input[name="advertiser_role"]:checked',
);
const hiddenInputElement = document.getElementById('advertiserRoleHiddenInput');

function showRadioButtons() {
  document
    .querySelector('.form_row_role')
    .classList.remove('form_row_role_set');
  if (hiddenInputElement) {
    hiddenInputElement.remove();
  }
}

// User switches between whole property and single room ads and not all roles are shared
function checkUserCurrentRoleExists() {
  const roleButtons = document.querySelectorAll(
    '.form_radio input[name="advertiser_role"]',
  );

  return Array.from(roleButtons).every(
    (button) => button.value !== hiddenInputElement.value,
  );
}

if (advertiserRoleButton) {
  const roleNotAvailable = checkUserCurrentRoleExists();
  if (roleNotAvailable) {
    showRadioButtons();
  }
  advertiserRoleButton.addEventListener('click', () => {
    showRadioButtons();
  });
}

if (checkedRadioButton) {
  showRadioButtons();
}
